/**
 * SocialMediaButton
 *    buttons={['facebook', 'twitter', 'wechat']}
 *	/>
 *
 * - When there is a nesting tr, we use tbody as a row.
 *
 * @parent anybody
 * @children
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames';
import locale from './locale';
import QrCode from 'template/Modals/QrCode';
import './SocialMediaButton.scss';

class SocialMediaButton extends React.Component {
  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(props) {
    super(props);

    this.renderButtons = this.renderButtons.bind(this);
    this.targets = {};
    this.state = {
      show: false,
      data: null,
    }
  }

  componentWillMount() {

  }

  renderButtons() {
    const {
      buttons,
      pageUrl,
      pageTitle,
    } = this.props;

    const url = encodeURI(pageUrl);
    const title = encodeURI(pageTitle);

    const BUTTONS = {
      'facebook': {
        label: __('Facebook', locale),
        icon: 'fa icon-facebook',
        onClick: ()=>{
          this.windowOpen(`https://www.facebook.com/sharer/sharer.php?u=${url}&quote=${title}`, { name: "Share on Facebook" });
        },
      },
      'twitter': {
        label: __('Twitter', locale),
        icon: 'fa icon-twitter',
        onClick: ()=>{
          this.windowOpen(`https://twitter.com/intent/tweet?url=${url}`, { name: "Share on Twitter" });
        },
      },
      'wechat': {
        label: __('WeChat', locale),
        icon: 'fa icon-wechat',
        onClick: ()=>{
          QrCode({ 
            title: __('Share on WeChat', locale), 
            icon: 'fa icon-wechat', 
            value: pageUrl,
            showDownloadBtn: true
          });
        },
      },
    }

    return buttons.map((buttonName, key)=>{
      const { icon, label, onClick } = BUTTONS[buttonName];
      return (
        <a className='btn btn-default' key={key} onClick={onClick} ref={(ref)=>{ this.targets[buttonName] = ref; }}>
          <i className={icon}/> {label}
        </a>
      );    
    });
  }

  render() {
    const {
      container,
      pageUrl,
    } = this.props;

    return (
      <div className='social-media-button'>
        {this.renderButtons()}
      </div>
    )
  }

  windowOpen(url, { name, height = 400, width = 550 }, onShareWindowClose) {
    /* eslint-disable no-mixed-operators */
    const left = (window.outerWidth / 2)
      + (window.screenX || window.screenLeft || 0) - (width / 2);
    const top = (window.outerHeight / 2)
      + (window.screenY || window.screenTop || 0) - (height / 2);
    /* eslint-enable no-mixed-operators */

    const config = {
      height,
      width,
      left,
      top,
      location: 'no',
      toolbar: 'no',
      status: 'no',
      directories: 'no',
      menubar: 'no',
      scrollbars: 'yes',
      resizable: 'no',
      centerscreen: 'yes',
      chrome: 'yes',
    };

    const shareDialog = window.open(
      url,
      this.isInternetExplorerBefore(10) ? '' : name,
      Object.keys(config).map(key => `${key}=${config[key]}`).join(', '),
    );

    if (onShareWindowClose) {
      const interval = window.setInterval(() => {
        try {
          if (shareDialog === null || shareDialog.closed) {
            window.clearInterval(interval);
            onShareWindowClose(shareDialog);
          }
        } catch (e) {
          /* eslint-disable no-console */
          console.error(e);
          /* eslint-enable no-console */
        }
      }, 1000);
    }

    return shareDialog;
  }

  isInternetExplorerBefore(version) {
    const iematch = (/MSIE ([0-9]+)/g.exec(window.navigator.userAgent));

    return iematch ? +iematch[1] < version : false;
  }

}

export default SocialMediaButton;



// WEBPACK FOOTER //
// ./src/shared/SocialMediaButton/index.js